import { useCallback } from 'react';
import { message } from 'antd';
import { fileApi } from '@services/Invitation/Invitation';
import config from '@config';
import RichEditor from '@components/common/RichEditor';

/** 会议微站富文本模块 */
const Editor = ({ editorContents, setEditorContents }) => {
    const editorId = 'conference-site-editor';

    const getFileUrl = useCallback(url => {
        if (url?.includes('https')) {
            return url;
        }
        if (url) {
            return config.OSS_PREFIX + url;
        }
        return null;
    }, []);

    const imageUploadHandler = useCallback(
        async blobInfo => {
            const formData = new FormData();
            formData.append('file', blobInfo.blob());
            formData.append('type', 13);

            try {
                const res = await fileApi(formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (res?.data) {
                    const fileUrl = getFileUrl(res.data);
                    if (fileUrl) {
                        return fileUrl;
                    }
                }
                throw new Error('缺少文件地址');
            } catch (error) {
                console.error('图片上传失败:', error);
                message.error('图片上传失败');
                throw error;
            }
        },
        [getFileUrl],
    );

    const handleChange = useCallback(
        html => {
            setEditorContents(html === '' ? '' : html);
        },
        [setEditorContents],
    );

    return <RichEditor id={editorId} mode="full" medProjectToolbar height={500} value={editorContents ?? ''} onChange={handleChange} imageUploadHandler={imageUploadHandler} />;
};

export default Editor;
